 <div *ngIf="isMobile; else webLogin" class="full-container">
  <!-- <div class="mobile-header">
    <div class="mobile-title">
      P2P Energy Trading Dashboard
    </div>
    <img (click)="logout()" class="mobile-logo" src="assets/hygge_hamburger_menu.png" alt="hygge_hamburger_menu">
  </div> -->
  <div class="market-container">
    <div class="container-elements">
      <div class="top-content">
        <div class="bid-title-mobile" *ngIf="activeBid">
          Bid is open from {{activeBid.bid_start}} to {{activeBid.bid_end}}
        </div>
        <div class="cards">
          <div class="purchase-info-mobile" [ngClass]="{'disabled-div': role === 'Prosumer'}">
            <div class="weekly-purchase-mobile">
              <div class="description-mobile">
                Purchased <br> this week
              </div>
              <div class="purchase-amount-mobile">
                {{energy.total_purchased_week.total_energy}} <br> <span class="subtext-mobile">kwh</span>
              </div>
              <div class="average-purchase-amount-mobile">
                {{energy.total_purchased_week.avg_price}} <br> <span class="subtext-mobile">Avg Price</span>
              </div>
            </div>
            <div class="divider-purchase"></div>
            <div class="total-purchase-mobile">
              <div class="description-mobile">
                Purchased <br> Total
              </div>
              <div class="purchase-amount-mobile">
                {{energy.total_purchased.total_energy}} <br> <span class="subtext-mobile">kwh</span>
              </div>
              <div class="average-purchase-amount-mobile">
                {{energy.total_purchased.avg_price}} <br> <span class="subtext-mobile">Avg Price</span>
              </div>
            </div>
          </div>
  
          <div class="supply-info-mobile" [ngClass]="{'disabled-div': role === 'Consumer'}">
            <div class="weekly-supply-mobile">
              <div class="description-mobile">
                Supplied <br> this week
              </div>
              <div class="supply-amount-mobile">
                {{energy.total_sold_week.total_energy}} <br> <span class="subtext-mobile">kwh</span>
              </div>
              <div class="average-supply-amount-mobile">
                {{energy.total_sold_week.avg_price}} <br> <span class="subtext-mobile">Avg Price</span>
              </div>
            </div>
            <div class="divider-supply"></div>
            <div class="total-supply-mobile">
              <div class="description-mobile">
                Supplied <br> Total
              </div>
              <div class="supply-amount-mobile">
                {{energy.total_sold.total_energy}} <br> <span class="subtext-mobile">kwh</span>
              </div>
              <div class="average-supply-amount-mobile">
                {{energy.total_sold.avg_price}} <br> <span class="subtext-mobile">Avg Price</span>
              </div>
            </div>
          </div>
  
          <div class="active-bid-info-mobile" *ngIf="activeBid">
            <div (click)="navigateToBidRound()" class="active-bid-mobile" [ngClass]="{'active-bid-mobile-buy': activeBid.transaction_type === 'Buy', 
                      'active-bid-mobile-sell': activeBid.transaction_type === 'Sell'}">
              Active Bid for {{activeBid.bid_end}} <br> {{activeBid.transaction_type}},
              {{activeBid.bid_type}}, {{activeBid.energy_amount}} Units &#64; {{activeBid.bid_price}} Rs.
            </div>
  
            <div class="bid-status-button-mobile" [ngClass]="{'bid-status-button-buy-mobile': activeBid.transaction_type === 'Buy', 
                      'bid-status-button-sell-mobile': activeBid.transaction_type === 'Sell'}">
              <button (click)="navigateToBidRound()">Bid Status</button>
            </div>
          </div>
        </div>
      </div>
  
      <div class="bottom-content">
        <div class="buy-and-sell-buttons">
          <div class="buy-button">
            <button (click)="navigateTo('buy')" [disabled]="role === 'Prosumer'">BUY</button>
          </div>
          <div class="sell-button">
            <button (click)="navigateTo('sell')" [disabled]="role === 'Consumer'">SELL</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #webLogin>
  <main class="main-content">
    <section class="trading">

      <div   class="trading-box first-trading-box"
      [ngClass]="{'disabled-div': !buy}">
        <div class="purchase-info">
          <div class="weekly-purchase">
            <div class="amount">{{energy.total_purchased_week.total_energy}}</div>
            <div class="description">Kwh<br />Purchased this <br />week</div>
            <div class="avg-price">Avg Price: {{energy.total_purchased_week.avg_price}}</div>
          </div>
          <img class="icon" src="assets/logo_transparent.png" alt="Hygge Icon" />
          <div class="total-purchase">
            <div class="amount-large">{{energy.total_purchased.total_energy}}</div>
            <div class="description-large">Kwh<br />Total Purchased</div>
            <div class="avg-price">Avg Price: {{energy.total_purchased.avg_price}}</div>
          </div>
        </div>
        <button class="action-btn buy-btn" (click)="navigateTo('buy')" [disabled]="!buy">Buy</button>
      </div>

      <div class="trading-box second-trading-box"
      [ngClass]="{'disabled-div': !sell}">
        <div class="supply-info">
          <div class="weekly-supply">
            <div class="amount">{{energy.total_sold_week.total_energy}}</div>
            <div class="description">Kwh<br />Supplied this <br />week</div>
            <div class="avg-price">Avg Price: {{energy.total_sold_week.avg_price}}</div>
          </div>
          <img class="icon" src="assets/logo_transparent.png" alt="Hygge Icon" />
          <div class="total-supply">
            <div class="amount-large">{{energy.total_sold.total_energy}}</div>
            <div class="description-large">Kwh<br />Total Supplied</div>
            <div class="avg-price">Avg Price: {{energy.total_sold.avg_price}}</div>
          </div>
        </div>
        <button class="action-btn sell-btn" (click)="navigateTo('sell')" [disabled]="!sell">Sell</button>
      </div>
    </section>
    <div class="active-bid-info" *ngIf="activeBid">
      <div (click)="navigateToBidRound()" class="active-bid">
        Active Bid for {{activeBid.bid_end}} <br> <span [ngClass]="{'bid-type-web-buy': activeBid.transaction_type === 'Buy', 
            'bid-type-web-sell': activeBid.transaction_type === 'Sell'}">{{activeBid.transaction_type}}</span>,
        {{activeBid.bid_type}}, {{activeBid.energy_amount}} Units &#64; {{activeBid.bid_price}} Rs.
      </div>

      <div class="bid-status-button" [ngClass]="{'bid-status-button-buy': activeBid.transaction_type === 'Buy', 
            'bid-status-button-sell': activeBid.transaction_type === 'Sell'}">
        <button class="go-to-button" (click)="navigateToBidRound()">Bid Status</button>
      </div>
    </div>
  </main>
</ng-template>
